import React from 'react';
import { CharacterStats, StatType } from '../../../../../shared/CharacterTypes';
import { COLORS, SPACE, FONT_SIZE, FONT_WEIGHT, RADII } from '../../../theme';

interface MiniStatsDisplayProps {
  stats: CharacterStats;
  level: number;
  statPoints?: number;
  onOpenStats?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const MiniStatsDisplay: React.FC<MiniStatsDisplayProps> = ({
  stats,
  level,
  statPoints,
  onOpenStats,
  className = '',
  style = {}
}) => {
  return (
    <div
      className={`mini-stats-display ${className}`}
      style={{
        background: COLORS.overlayScrim,
        backdropFilter: 'blur(5px)',
        padding: SPACE.lg,
        borderRadius: RADII.lg,
        border: `1px solid ${COLORS.borderSubtle}`,
        width: '100%',
        ...style
      }}
      onClick={onOpenStats}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: SPACE.md }}>
        <span style={{ color: COLORS.brandAccent, fontWeight: FONT_WEIGHT.bold, fontSize: FONT_SIZE.lg }}>Lv. {level}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm }}>
          {statPoints && statPoints > 0 ? (
            <span style={{
              background: COLORS.danger,
              color: COLORS.textPrimary,
              borderRadius: RADII.pill,
              width: 16,
              height: 16,
              fontSize: FONT_SIZE.xs,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'pulse 1s infinite'
            }} title={`${statPoints} Points Available`}>!</span>
          ) : null}
          <span aria-hidden>📊</span>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.xs, fontSize: FONT_SIZE.md }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: COLORS.textMuted }}>STR</span>
          <span style={{ color: COLORS.textPrimary }}>{stats[StatType.STRENGTH] || 0}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: COLORS.textMuted }}>DEX</span>
          <span style={{ color: COLORS.textPrimary }}>{stats[StatType.DEXTERITY] || 0}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: COLORS.textMuted }}>INT</span>
          <span style={{ color: COLORS.textPrimary }}>{stats[StatType.INTELLIGENCE] || 0}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: COLORS.textMuted }}>LUK</span>
          <span style={{ color: COLORS.textPrimary }}>{stats[StatType.LUCK] || 0}</span>
        </div>
      </div>

      {onOpenStats && (
        <div style={{
          marginTop: SPACE.md,
          textAlign: 'center',
          fontSize: FONT_SIZE.xs,
          color: COLORS.info,
          cursor: 'pointer'
        }}>
          Click to View Details
        </div>
      )}
    </div>
  );
};
